<template>
  <div class="h-full">
    <div class="header-top row">
        <div class="col-md-2">Previsões</div>
        <div class="col-md-8 center">7D</div>
        <div class="col-md-2 center">X</div>
    </div>
    
    <div class="weather-forecast">
      <div class="body-weather">
        <div class="header-nav p-5">
        <div class="col-md-2">Hoje</div>
          <div class="col-md-8 center">          
            <svg width="13.464" height="13.464" viewBox="0 0 13.464 13.464">
              <path id="navigation" d="M3,7.9,15.464,2,9.56,14.464,8.248,9.216Z" transform="translate(-2.5 -1.5)" fill="none" stroke="#353637" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </svg>
              São Paulo/SP
          </div>
          <div class="col-md-2">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M12 17.27L18.18 21 15.64 13.97 22 9.24 14.81 8.63 12 2 9.19 8.63 2 9.24 8.36 13.97 5.82 21z"/>
              </svg>
          </div>
      </div>
      <p class="center">terça-feira, 12 de março</p>
    <div class="header">
      <div class="main-info row">
        <div class="col-md-12 flex justify-content-center align-items-center">
          <span class="weathericon-detail">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 30.001 30">
          <g id="sun" transform="translate(0)">
            <rect id="Retângulo_2412" data-name="Retângulo 2412" width="30" height="30" fill="none"/>
            <g id="sun-2" data-name="sun" transform="translate(-13007.731 -2947)">
              <ellipse id="Elipse_451" data-name="Elipse 451" cx="8.133" cy="8.426" rx="8.133" ry="8.426" transform="translate(13014.6 2953.573)" fill="#ffcc01"/>
              <rect id="Retângulo_2336" data-name="Retângulo 2336" width="2.471" height="5.758" rx="1.235" transform="translate(13021.124 2947)" fill="#ffcc01"/>
              <rect id="Retângulo_2342" data-name="Retângulo 2342" width="2.471" height="5.758" rx="1.235" transform="translate(13021.124 2971.242)" fill="#ffcc01"/>
              <rect id="Retângulo_2339" data-name="Retângulo 2339" width="2.471" height="5.758" rx="1.235" transform="translate(13010.945 2952.411) rotate(-45)" fill="#ffcc01"/>
              <rect id="Retângulo_2340" data-name="Retângulo 2340" width="2.471" height="5.758" rx="1.235" transform="translate(13028.339 2969.648) rotate(-45)" fill="#ffcc01"/>
              <rect id="Retângulo_2337" data-name="Retângulo 2337" width="2.471" height="5.758" rx="1.235" transform="translate(13032.026 2949.561) rotate(45)" fill="#ffcc01"/>
              <rect id="Retângulo_2338" data-name="Retângulo 2338" width="2.471" height="5.758" rx="1.235" transform="translate(13014.682 2967.517) rotate(45)" fill="#ffcc01"/>
              <rect id="Retângulo_2341" data-name="Retângulo 2341" width="2.158" height="5.754" rx="1.079" transform="translate(13013.485 2960.961) rotate(90)" fill="#ffcc01"/>
              <rect id="Retângulo_2343" data-name="Retângulo 2343" width="2.471" height="5.758" rx="1.235" transform="translate(13037.732 2960.777) rotate(90)" fill="#ffcc01"/>
            </g>
          </g>
         </svg>
        </span>
              <span class="temp-max flex">
                <span>
                  <span class="h1">30°</span>
                  <p>Máxima</p>
                </span>
                
              </span>
          </div>
        </div>
        
      <div class="details">
          <p class="center mb-3">
            <span>              
              <svg id="Grupo_7245" data-name="Grupo 7245" xmlns="http://www.w3.org/2000/svg" width="17.281" height="13.813" viewBox="0 0 17.281 13.813">
                <path id="Caminho_3021" data-name="Caminho 3021" d="M28.029,20.545a.415.415,0,0,1,.265.09c.336.283,3.287,2.8,3.287,4.252,0,1.534-1.581,2.782-3.524,2.782s-3.524-1.248-3.524-2.782c0-1.448,2.9-3.967,3.229-4.25a.405.405,0,0,1,.228-.09l.037,0ZM17.55,23.578a.414.414,0,0,1,.265.09c.263.221,1.576,1.36,1.576,2.075a1.672,1.672,0,0,1-1.828,1.443,1.672,1.672,0,0,1-1.828-1.443c0-.714,1.289-1.853,1.548-2.073a.4.4,0,0,1,.227-.091l.037,0Zm10.482-2.32c-.965.867-2.772,2.687-2.772,3.629a2.559,2.559,0,0,0,2.8,2.209,2.559,2.559,0,0,0,2.8-2.209C30.855,23.945,29.013,22.124,28.032,21.258ZM17.553,24.3c-.518.485-1.091,1.139-1.091,1.448a1.007,1.007,0,0,0,1.1.87,1.008,1.008,0,0,0,1.1-.87C18.664,25.435,18.08,24.78,17.553,24.3Zm4.112-5.3a.414.414,0,0,1,.265.09c.263.221,1.576,1.36,1.576,2.075A1.672,1.672,0,0,1,21.678,22.6a1.672,1.672,0,0,1-1.828-1.443c0-.714,1.289-1.853,1.548-2.073a.4.4,0,0,1,.227-.091l.037,0Zm0,.718c-.518.485-1.091,1.139-1.091,1.448a1.132,1.132,0,0,0,2.2,0C22.779,20.849,22.194,20.194,21.667,19.71Zm-4.844-5.854a.414.414,0,0,1,.265.09c.235.2,2.3,1.959,2.3,2.992a2.326,2.326,0,0,1-2.543,2.007A2.326,2.326,0,0,1,14.3,16.939c0-1.032,2.026-2.793,2.256-2.991a.4.4,0,0,1,.228-.091l.037,0Zm0,.715c-.785.716-1.8,1.823-1.8,2.368a1.661,1.661,0,0,0,1.816,1.434,1.661,1.661,0,0,0,1.816-1.434C18.659,16.393,17.625,15.286,16.825,14.571Zm8.712.026a.413.413,0,0,1,.264.09c.263.221,1.576,1.36,1.576,2.075a1.672,1.672,0,0,1-1.828,1.443,1.672,1.672,0,0,1-1.828-1.443c0-.714,1.29-1.853,1.548-2.074a.405.405,0,0,1,.228-.09l.037,0Zm0,.718c-.518.485-1.091,1.139-1.091,1.448a1.132,1.132,0,0,0,2.2,0C26.652,16.455,26.067,15.8,25.54,15.315Z" transform="translate(-14.3 -13.856)" fill="#747474"/>
              </svg>
            </span>
            Precipitação: 2%
          </p>
          <p class="center m-3">Ensolarado a parcialmente nublado</p>
          <p class="center mb-3">Atualizado de minuto a minuto</p>
        </div>
    </div>
      </div>
      
    <div class="header-top"><h4>Condições Atuais</h4></div>
    <div class="current-conditions">
      <div class="conditions block">
        <div class="condition p-2 pl-4 pr-5"><span>Temperatura Máxima (°C):</span><span class="float-right bold"> 20,7</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Temperatura Mínima (°C):</span> <span class="float-right bold">17</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Chuva (mm):</span> <span class="float-right bold">26</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Vento Velocidade (m/s):</span> <span class="float-right bold">3,7</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Vento Direção:</span> <span class="float-right bold">360</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Pressão Máxima (hPa):</span> <span class="float-right bold">998,3</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Pressão Mínima (hPa):</span> <span class="float-right bold">998,3</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Umidade Máxima (%):</span> <span class="float-right bold">998,3</span></div>
        <div class="condition p-2 pl-4 pr-5"><span>Umidade Mínima (%):</span> <span class="float-right bold">998,3</span></div>
      </div>
    </div>
    <div class="weekly-forecast">
      <div class="day" v-for="day in weeklyForecast" :key="day.date">
        <div class="date">{{ day.date }}</div>
        <div class="icon">
          <img :src="day.icon" alt="Weather Icon">
        </div>
        <div class="temps">
          <span>{{ day.minTemp }} °C</span> - <span>{{ day.maxTemp }} °C</span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'WeatherForecast',
  data() {
    return {
      weeklyForecast: [
        { date: 'Seg 05/03', icon: '../images/icons/wind.svg', minTemp: 21, maxTemp: 32 },
        { date: 'Ter 06/03', icon: 'path/to/partly-cloudy.png', minTemp: 21, maxTemp: 32 },
        { date: 'Qua 07/03', icon: 'path/to/rainy.png', minTemp: 21, maxTemp: 32 },
        { date: 'Qui 08/03', icon: 'path/to/sunny.png', minTemp: 21, maxTemp: 32 },
        { date: 'Sex 09/03', icon: 'path/to/partly-cloudy-rain.png', minTemp: 21, maxTemp: 32 },
      ]
    };
  }
}
</script>

<style>
.weather-forecast {
  color: #333;
  width: 400px;
  margin: 0 auto;
  
  overflow-y: scroll;
  overflow-x: hidden;
  height: 80%;
}
.desktop .weather-forecast::-webkit-scrollbar {
  width: 2px;
}
.desktop .weather-forecast::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.theme-dark .weather-forecast::-webkit-scrollbar-track {
  background: #3e4852;
}
.desktop .weather-forecast::-webkit-scrollbar-thumb {
  background: #b4b7bd;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
}
.theme-dark .weather-forecast::-webkit-scrollbar-thumb {
  background-color: #636b74;
  border-radius: 10px;
  border: 1px solid #636b74;
}
.desktop .weather-forecast::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.theme-dark .desktop .weather-forecast::-webkit-scrollbar-thumb:hover {
  background: #000;
}

.header-top {
    display: flex;
    background-color: #fcfcfc;
    border-bottom: 1px solid #DDD;
    padding: 10px;
}
.header {
  text-align: center;
}
.header-nav{
  display: flex;
  background-color: #FFF;
}
.main-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.temperature-detail {
  font-size: 40px;
}

.details {
  text-align: left;
}

.current-conditions {
  
}

.conditions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.weekly-forecast {
  display: flow;
  justify-content: space-between;
  margin-top: 20px;
}

.day {
  text-align: center;
}

.icon img {
  width: 40px;
  height: 40px;
}
.weather-forecast {
  background: #fff;
}

.header h2, .header h3, .header p {
  margin: 0;
}

.header .main-info {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header .main-info .temperature {
  font-size: 50px;
  font-weight: bold;
}

.header .main-info .details {
  text-align: left;
}

.header .main-info .details button {
  background: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.header .main-info .details button:hover {
  background: #0056b3;
}


.current-conditions h4 {
  margin-bottom: 10px;
}

.current-conditions .conditions {
  display: flex;
  flex-wrap: wrap;
}

.current-conditions .conditions .condition {
  width: 100%;
  border-bottom: 1px solid #ddd;
}

.weekly-forecast {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.weekly-forecast .day {
  text-align: center;
}

.weekly-forecast .day .icon {
  margin: 5px 0;
}

.weekly-forecast .day .temps {
  font-size: 14px;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
}
p.temp-max {
    font-size: 20px;
    position: absolute;
    margin-left: 60px;
    margin-top: 30px;
}
.weathericon-detail{
  text-align: right;
}

</style>